import { makeObservable, observable, action, computed } from "mobx";
import { Article } from "src/components/articlePreview";
import { getArticleCount, SchemaType } from "src/modules/sanityApi";

interface TimelineEntry {

}

export class SiteModel {
	@observable entries: any[];
	totalAvailableTimelineEntries: number;
	lastEntryDate: string;
	lastEntryId: string;

	/** Add timeline entries to the timelineEntries array. Any entries with repeat slugs will be ignored. */
	@action addTimelineEntries(entries: any | any[]){
		const slugs = this.entries.reduce((accumulator, entry) => [...accumulator, entry.slug.current], []);
		if (Array.isArray(entries)) {
			const newEntries = entries.filter(entry => !slugs.includes(entry.slug.current)); // it is still possible for the incoming array to contain dupes... not sure if it matters
			this.entries = [...this.entries, ...newEntries];
			this.lastEntryDate = newEntries[newEntries.length-1].date;
			this.lastEntryId = newEntries[newEntries.length-1]._id;
		}
		else if (!slugs.includes(entries.slug.current)) {
			this.entries = [...this.entries, entries]
		}
	}

	@computed get timelineEntries() {
		return this.entries;
	}

	@computed get timelineHasLoaded(){
		return this.entries.length > 0;
	}

	@computed get numberOfTimelineEntries(){
		return this.entries.length;
	}

	@computed get allArticlesLoaded(): boolean{
		return this.numberOfTimelineEntries == this.totalAvailableTimelineEntries;
	} 

	setTotalAvailableTimelineEntries(amount: number){
		this.totalAvailableTimelineEntries = amount;
	}

	@observable songs: any[];

	/** Add timeline entries to the songs array. Any songs with repeat slugs will be ignored. */
	@action addSongs(songs: any | any[]){
		const slugs = this.songs.reduce((accumulator, song) => [...accumulator, song.slug.current], []);
		if (Array.isArray(songs)) {
			const newSongs = songs.filter(song => !slugs.includes(song.slug.current)); // it is still possible for the incoming array to contain dupes... not sure if it matters
			this.songs = [...this.songs, ...newSongs];
		}
		else if (!slugs.includes(songs.slug.current)) {
			this.songs = [...this.songs, songs]
		}
	}

	@computed get allSongs() {
		return this.songs;
	}

	@computed get songsHaveLoaded(){
		return this.songs.length > 0;
	}

	@observable credits: any[];

	// set credits rather than add or whatever because the credits are assumed to not contain any images which means it's likely not a problem to just load all of them at once
	@action setCredits(credits: any | any[]){
		this.credits = credits;
	}

	@computed get creditsHaveLoaded(){
		return this.credits.length > 0;
	}

	constructor(){
		this.credits = [];
		this.entries = [];
		this.songs = []
		makeObservable(this);
	}
}